import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'TEAMSEASONMEMBER',
  inside: {
    team: { get: 'teamSeasonMembers' },
  },
});
